export const ROOT = '/';
export const VIPS = '/vips';
export const CREATE_VIPS = '/create-vips';
export const EDIT_VIP = '/edit-vip';
export const LOTS = '/lots';
export const CSV = '/csv';
export const REVIEW_VIPS = '/review-vips';
